import styles from './HybridMarkdownEditor.module.css'
import {type MarkdownViewMode, ViewSwitch} from './ViewSwitch'

export interface HybridMarkdownEditorProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  onChangeViewMode?: (newViewMode: MarkdownViewMode) => void
}

export function HybridMarkdownEditor({value, onChange, disabled, onChangeViewMode}: HybridMarkdownEditorProps) {
  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <div className={styles.viewSwitch}>
          <ViewSwitch selectedView="hybrid" onViewSelect={onChangeViewMode} />
        </div>
        <div className={styles.formattingTools} />
      </div>
      <div className={styles.content}>
        <p>Nothing to see here yet. Come back later!</p>
        <textarea
          aria-label="Markdown value"
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  )
}

try{ HybridMarkdownEditor.displayName ||= 'HybridMarkdownEditor' } catch {}